import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import { useSelector } from 'react-redux';
import * as S from './styles';
import { SIDEBAR_STATE } from '../../../sidebar/constants';

export const FILTER_PORTAL_ID = 'sidebar-filter';

const SidebarFilter = ({ children }: { children: React.ReactNode }) => {
  const { t } = React.useContext(AppContext);
  const [portalTarget, setPortalTarget] = useState();
  const sidebarTab = useSelector((state: any) => state.areas.sidebar.tab);

  /**
   * The whole filter slice is rendered through a portal in order to keep it
   * within the route data structure while still being able to show it in the
   * sidebar. We have to do this little dance with local state and an effect
   * to make sure the portal target has been rendered before trying to render
   * into it.
   */
  useEffect(() => {
    if (sidebarTab === SIDEBAR_STATE.FILTER) {
      setPortalTarget(document.getElementById(FILTER_PORTAL_ID));
    }
  }, [sidebarTab]);

  if (!portalTarget) {
    return null;
  }

  return ReactDOM.createPortal(
    <S.Filter>
      <S.FilterTitle>{t('filter', 'filter.title')}</S.FilterTitle>
      {children}
    </S.Filter>,
    portalTarget
  );
};

export default SidebarFilter;
